<template>
  <CardWithTitle
    :request-status="requestStatus"
    :item-id="itemId"
    :options-data="baseCardOptions"
    @call-option-menu="callOptionMenu"
    @reload="reload"
  >
    <!-- using dark and light properties to fix https://github.com/vuetifyjs/vuetify/issues/8392 -->
    <v-carousel
      v-if="hasPost"
      continuous
      :dark="$vuetify.theme.dark"
      :light="!$vuetify.theme.dark"
      height="635"
      :show-arrows="false"
      hide-delimiter-background
    >
      <v-carousel-item
        v-for="post in posts"
        :key="post._id"
      >
        <div class="centralize-post pt-5">
          <Post
            :post="post"
          />
        </div>
      </v-carousel-item>
    </v-carousel>
    <h2
      v-else
      class="no-post-title pt-16"
    >
      {{ noPostsLabel }}
    </h2>

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import { mapActions } from 'vuex';
import cardsModel from '@/mixins/cards-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import Post from '@/components/Post/Post';
import EventBus from '@/utils/event-bus';
import Badge from '@/components/Badge';

export default {
  name: 'TopPosts',
  components: {
    CardWithTitle,
    Post,
    Badge,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      posts: [],
      requestStatus: 'loading',
    };
  },
  computed: {
    noPostsLabel() {
      return this.$t('components.TopPosts.label.noPostsLabel');
    },
    hasPost() {
      return this.posts && this.posts.length;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    reload() {
      this.getData();
    },
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'topPosts',
        serviceParams: {
          limit: 3,
        },
      })
        .then(response => {
          this.posts = response.posts;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
  ::v-deep {
    .centralize-post {
      display: flex;
      justify-content: center;
      flex-direction: column;

      > div {
        margin: 0 auto 30px auto;
      }
    }
  }

  .no-post-title {
    font-size: 18px;
    text-align: center;
    color: white;
  }
</style>
